import "core-js/modules/es.array.reduce.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["children"];
var _this5 = this;
import "core-js/modules/es.array.reduce.js";
import React from 'react';
import pt from 'prop-types';
import { Element, BreakpointContext, breakpointPropSwitch } from '../';
import { appendHtmlClass, extendProps, colorPropType, borderPropType, getSpaceValue, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var MASK_TYPE = getConfig('MASK_TYPE');
var MASK_TYPE_PREFIX = getConfig('MASK_TYPE_PREFIX');
var BORDER_RADIUS_SCALE = getConfig('BORDER_RADIUS_SCALE');
var BORDER_RADIUS_PREFIX = getConfig('BORDER_RADIUS_PREFIX');
var CORNER_SIDE_ORDER = getConfig('CORNER_SIDE_ORDER');
var BOX_SIDE_ORDER = getConfig('BOX_SIDE_ORDER');
var BOX_SHADOW_SCALE = getConfig('BOX_SHADOW_SCALE');
var BOX_SHADOW_PREFIX = getConfig('BOX_SHADOW_PREFIX');
var BACKGROUND_COLOR_PREFIX = getConfig('BACKGROUND_COLOR_PREFIX');
var BORDER_PREFIX = getConfig('BORDER_PREFIX');
var BORDER_DEFAULT = getConfig('BOX_BORDER_DEFAULT');
var SPACING_PROPERTIES = ['padding', 'margin'];
var DIMENSION_PROPERTIES = ['width', 'height'];
var BoxHelper = /*#__PURE__*/function () {
  function BoxHelper() {}
  BoxHelper.getResponsiveValue = function getResponsiveValue(options, context) {
    return breakpointPropSwitch(options, context);
  };
  BoxHelper.getSidedProps = function getSidedProps(context, props, name) {
    var _this = this;
    var each = props[name] ? this.getResponsiveValue(props[name], context) : null;
    var sides = BOX_SIDE_ORDER.map(function (side) {
      var sideName = name + side.value.substring(0, 1).toUpperCase() + side.value.substring(1);
      var value = props[sideName] ? _this.getResponsiveValue(props[sideName], context) : null;
      return {
        key: side.key,
        value: value,
        prop: side.value
      };
    });
    return {
      each: each,
      sides: sides
    };
  };
  BoxHelper.getBorderClass = function getBorderClass(context, props) {
    var _this$getSidedProps = this.getSidedProps(context, props, 'border'),
      each = _this$getSidedProps.each,
      sides = _this$getSidedProps.sides;
    var sameCls = 0;
    var eachCls = null;
    var sideCls = '';
    sides.forEach(function (_ref) {
      var key = _ref.key,
        value = _ref.value;
      if (each !== null && value === null) value = each;
      if (value !== null) {
        if (value.length === 1) value = value.merge(BORDER_DEFAULT.slice(1));
        var cls = value.join('-');
        sideCls = appendHtmlClass(sideCls, "" + BORDER_PREFIX + key + "-" + cls);
        cls = "" + BORDER_PREFIX + cls;
        if (sameCls <= 0) eachCls = cls;
        if (eachCls === cls) sameCls++;
      }
    });
    return sameCls >= sides.length ? eachCls : sideCls;
  };
  BoxHelper.getSpacingStyle = function getSpacingStyle(context, props, name) {
    var _ref2;
    var _this$getSidedProps2 = this.getSidedProps(context, props, name),
      each = _this$getSidedProps2.each,
      sides = _this$getSidedProps2.sides;
    if (each !== null) {
      var eachSides = this.getCssSides(Array.isArray(each) ? each : [each], BOX_SIDE_ORDER);
      sides = sides.map(function (i, index) {
        return i.value !== null ? i : eachSides[index];
      });
    }
    var same = sides.reduce(function (prev, current) {
      return prev !== null && prev === current ? prev : null;
    });
    if (same !== null) return _ref2 = {}, _ref2[name] = getSpaceValue(same), _ref2;
    var style = {};
    sides.forEach(function (i) {
      if (i.value !== null) {
        var prop = name + i.prop.substring(0, 1).toUpperCase() + i.prop.substring(1);
        style[prop] = getSpaceValue(i.value);
      }
    });
    return style;
  };
  BoxHelper.getCssSides = function getCssSides(prop, order) {
    return order.map(function (_ref3, index) {
      var key = _ref3.key,
        value = _ref3.value;
      var val = null;
      if (index === 0) val = prop[index];else if (index === 1) val = prop.length > index ? prop[index] : prop[index - 1];else if (index < 4) {
        if (prop.length > index) val = prop[index];else if (prop.length > index - 2) val = prop[index - 2];else if (prop.length > index - 3) val = prop[index - 3];
      }
      return {
        key: key,
        value: val,
        prop: value
      };
    });
  };
  BoxHelper.getDimensionStyle = function getDimensionStyle(context, props, name) {
    var _ref4;
    var prop = props[name];
    if (!prop) return {};
    var value = this.getResponsiveValue(prop, context);
    value = typeof value == 'number' ? getSpaceValue(value) : value;
    return _ref4 = {}, _ref4[name] = value, _ref4;
  };
  return BoxHelper;
}();
var Box = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Box, _React$Component);
  function Box() {
    var _this2;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this2.DEFAULT_CLASS = 'box';
    _this2.ALLOWED_PROPS = ['as', 'children', 'bg', 'shadow', 'corner', 'mask', 'innerRef', 'width', 'height', 'align', 'className', 'id', 'style', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight'];
    return _this2;
  }
  var _proto = Box.prototype;
  _proto.getShadowClass = function getShadowClass() {
    if (this.props.shadow) {
      var shadow = BoxHelper.getResponsiveValue(this.props.shadow, this.context);
      return "" + BOX_SHADOW_PREFIX + shadow;
    }
    return null;
  };
  _proto.getBackgroundClass = function getBackgroundClass() {
    if (!this.props.bg) return null;
    var color = BACKGROUND_COLOR_PREFIX;
    if (typeof this.props.bg == 'string') return color + this.props.bg;
    for (var i = 0; i < this.props.bg.length; i++) {
      if (i < 1) color += this.props.bg[i];else color += '-' + this.props.bg[i];
    }
    return color;
  };
  _proto.getCornerClass = function getCornerClass() {
    var prop = this.props.corner;
    if (!prop) return '';
    if (!Array.isArray(prop)) return "" + BORDER_RADIUS_PREFIX + prop;
    if (prop.length <= 0) return '';
    var sides = BoxHelper.getCssSides(prop, CORNER_SIDE_ORDER);
    var sameCls = 0;
    var eachCls = null;
    var sideCls = '';
    sides.forEach(function (_ref5) {
      var key = _ref5.key,
        value = _ref5.value;
      if (value !== null) {
        var cls = value;
        sideCls = appendHtmlClass(sideCls, "" + BORDER_RADIUS_PREFIX + key + "-" + cls);
        cls = "" + BORDER_RADIUS_PREFIX + cls;
        if (sameCls <= 0) eachCls = cls;
        if (eachCls === cls) sameCls++;
      }
    });
    return sameCls >= sides.length ? eachCls : sideCls;
  };
  _proto.getMaskClass = function getMaskClass() {
    return this.props.mask ? "" + MASK_TYPE_PREFIX + MASK_TYPE[this.props.mask] : null;
  };
  _proto.getClass = function getClass() {
    var className = this.props.className;
    var classes = [this.DEFAULT_CLASS, this.getMaskClass(), this.getCornerClass(), this.getShadowClass(), this.getBackgroundClass(), BoxHelper.getBorderClass(this.context, this.props)];
    classes.forEach(function (i) {
      className = appendHtmlClass(className, i);
    });
    return className;
  };
  _proto.getStyle = function getStyle() {
    var _this3 = this;
    var style = typeof this.props.style == 'object' ? this.props.style : {};
    var result = {};
    SPACING_PROPERTIES.forEach(function (prop) {
      Object.assign(result, style, BoxHelper.getSpacingStyle(_this3.context, _this3.props, prop));
    });
    DIMENSION_PROPERTIES.forEach(function (prop) {
      Object.assign(result, style, BoxHelper.getDimensionStyle(_this3.context, _this3.props, prop));
    });
    return result;
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$props = this.props,
      align = _this$props.align,
      id = _this$props.id,
      children = _this$props.children,
      innerRef = _this$props.innerRef;
    var otherProps = {};
    Object.keys(this.props).filter(function (prop) {
      return _this4.ALLOWED_PROPS.indexOf(prop) < 0;
    }).forEach(function (prop) {
      otherProps[prop] = _this4.props[prop];
    });
    return /*#__PURE__*/React.createElement(Element, Object.assign({
      as: this.props['as'],
      ref: innerRef,
      align: align,
      className: this.getClass(),
      id: id,
      style: this.getStyle()
    }, otherProps), children);
  };
  return Box;
}(React.Component);
Box.contextType = BreakpointContext;
var addSidePropValidation = function addSidePropValidation(prop, validator) {
  var box = {};
  BOX_SIDE_ORDER.forEach(function (side) {
    var sidedProp = prop + side.value.substring(0, 1).toUpperCase() + side.value.substring(1);
    box[sidedProp] = validator;
  });
  return box;
};
var boxProps = {
  /**
   * Name of HTML element e.g. main or div
   */
  as: pt.oneOf(['article', 'aside', 'details', 'dialog', 'div', 'fieldset', 'figure', 'footer', 'header', 'main', 'menu', 'menuitem', 'nav', 'pre', 'section', 'ul', 'ol', 'li', 'address', 'hgroup', 'form']),
  children: pt.node,
  /**
   * Background color e.g. ['primary', -1, 2], where the first param is color name, the second is lightness level ("t" - "h") and opacity level.
   */
  bg: colorPropType.bind(this, false),
  /**
   * Box shadow e.g. 2
   */
  shadow: responsivePropType.bind(this, pt.oneOf(BOX_SHADOW_SCALE.map(function (i) {
    return i.key;
  }))),
  /**
   * Border radius e.g. [0, 3, 5, 1]
   */
  corner: pt.oneOfType([pt.oneOf(BORDER_RADIUS_SCALE.map(function (i) {
    return i.key;
  })), pt.arrayOf(pt.oneOf(BORDER_RADIUS_SCALE.map(function (i) {
    return i.key;
  })))]),
  /**
   * Type of mask to apply if any
   */
  mask: pt.oneOf(Object.keys(MASK_TYPE)),
  /**
   * Reference to underlying element
   */
  innerRef: pt.any
};
SPACING_PROPERTIES.forEach(function (prop) {
  boxProps[prop] = responsivePropType.bind(_this5, pt.oneOfType([pt.number, pt.arrayOf(pt.number)]));
  var props = addSidePropValidation(prop, responsivePropType.bind(_this5, pt.number));
  Object.assign(boxProps, props);
});
DIMENSION_PROPERTIES.forEach(function (prop) {
  boxProps[prop] = responsivePropType.bind(_this5, pt.oneOfType([pt.number, pt.string]));
});
var borderProps = addSidePropValidation('border', responsivePropType.bind(this, borderPropType));
Object.assign(boxProps, borderProps);
Object.assign(Box, extendProps(Element, ['align', 'className', 'id', 'children', 'style', 'isAnimated'], boxProps, {
  as: 'div'
}));
var BoxWithRefs = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
    props = _objectWithoutPropertiesLoose(_ref6, _excluded);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    innerRef: ref
  }, props), children);
});
export { BoxWithRefs as Box, BoxHelper };